import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axiosInstance from "../api/axiosInstance";
import { delay } from "../helper/delayresponse";

interface Checkbalance {
    id?: number;
    name?: string;
    gateway: {
        name: string
    }
    balance?: string;
    currency?: string;
}

interface CheckbalanceState {
    checkbalancedata: Checkbalance[];
    info: {
        count: number;
        current_page: number;
        limit: number;
        total_page: number;
    } | null;
    error: string | null;
    loading: boolean;
}

export const GetallCheckBalance = createAsyncThunk<
    {
        data: Checkbalance[];
        info: {
            count: number;
            current_page: number;
            limit: number;
            total_page: number;
        };
    },
    { search: string; page: number; limit: number },
    { rejectValue: string }
>(
    "GetallCheckBalance",
    async ({ search, page, limit }, { rejectWithValue }) => {
        try {
            await delay(1000)
            const response = await axiosInstance.get(`api/admin/sms-gateways/balance`, {
                params: { search, page, limit },
            });

            return { data: response.data.data, info: response.data.info };
        }
        catch (error: any) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue(error.message);
        }
    }
);

const initialState: CheckbalanceState = {
    checkbalancedata: [],
    info: null,
    error: null,
    loading: false,
};

const checkbalanceSlice = createSlice({
    name: "Checkbalance",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // ===============get-all-checkbalance-slice-start============
            .addCase(GetallCheckBalance.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(
                GetallCheckBalance.fulfilled,
                (
                    state,
                    action: PayloadAction<{
                        data: Checkbalance[];
                        info: {
                            count: number;
                            current_page: number;
                            limit: number;
                            total_page: number;
                        };
                    }>
                ) => {
                    state.loading = false;
                    state.checkbalancedata = action.payload.data;
                    state.info = action.payload.info;
                }
            )
            .addCase(
                GetallCheckBalance.rejected,
                (state, action: PayloadAction<string | undefined>) => {
                    state.loading = false;
                    state.error = action.payload || "An error occurred";
                }
            );
        // ===============get-all-checkbalance-slice-end============

    },
});

export default checkbalanceSlice.reducer;
